// MessageProvider.tsx
import React, { createContext, useContext } from "react";
import { message } from "antd";

const MessageContext = createContext<any>(null);

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <MessageContext.Provider value={messageApi}>
      {contextHolder}
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageApi = () => {
  const ctx = useContext(MessageContext);
  if (!ctx) {
    throw new Error("useMessageApi must be used within MessageProvider");
  }
  return ctx;
};
